import type { FieldValues } from "react-hook-form";

import { type FlavorsSelection, type OrderFrequency, type PackagingPreference } from "@jti/fe-common";

export interface SticksFormValues extends FieldValues {
  orderFrequency: OrderFrequency;
  packagingPreference: PackagingPreference;
  flavors: FlavorsSelection;
  quantity: string;
}
